/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { useTranslation, Trans } from 'gatsby-plugin-react-i18next';

import * as urlHelper from '../../helpers/url.helper';
import QueryStringNavigate from '../QueryStringNavigate';
import './style.scss';

export const WPInterlinking = ({ isParentPage, linksList, language }) => {
  const { t } = useTranslation(['interlinking']);

  const zone = isParentPage
    ? t('interlinking.province')
    : t('interlinking.municipalityTitle');

  const municipality = isParentPage
    ? t('interlinking.province')
    : t('interlinking.municipalityFoot');

  const installationLink = urlHelper.getPathForOtherLanguage(
    '/placas-solares/instalacion/',
    language,
  );
  const contactLink = urlHelper.getPathForOtherLanguage('/contacto/', language);
  return (
    <div className="interlinking">
      <h2 className="title">
        <Trans
          t={t}
          i18nKey="interlinking.title"
          values={{ zone }}
          components={{
            hyperlink: (
              <a className="interlinkingTitle" href={installationLink} />
            ),
          }}
        >
          {t('interlinking.title')}
        </Trans>
      </h2>
      <div className="links">
        {linksList &&
          Array.isArray(linksList) &&
          linksList.length > 0 &&
          linksList.map((linkGroup, index) => (
            <div key={`${linkGroup[0].label} ${index}`}>
              {linkGroup.map((link) => (
                <QueryStringNavigate
                  className="interlinkingItem"
                  key={link.label}
                  path={
                    language === 'es' ? link.url : link.url.replace('/en/', '/')
                  }
                >
                  {link.label}
                </QueryStringNavigate>
              ))}
            </div>
          ))}
      </div>
      <p className="footCTA">
        {t('interlinking.copyCTA', { municipality })}{' '}
        <QueryStringNavigate className="labelCTALink" path={contactLink}>
          {t('interlinking.labelCTALink')}
        </QueryStringNavigate>
      </p>
    </div>
  );
};
